import * as React from 'react';

function FilterCounter({counter}) {
    return (
        <div className='filter__counter'>
            <p className='filter__inner'>{counter}</p>
        </div>
    )
}

export default FilterCounter;